import(/* webpackMode: "eager" */ "/work/apps/frontend/src/app/(buyer)/shopping/error.tsx");
